// extracted by mini-css-extract-plugin
export default {"container":"Vehicle_container__mDsqe","page":"Vehicle_page__vY5PF","section":"Vehicle_section__FQ7VL"};